module.exports = __webpack_public_path__ + "static/media/women.d15150db.jfif";